import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarStatusDropdownContentItemWireframe from './VeltCommentsSidebarStatusDropdownContentItemWireframe/VeltCommentsSidebarStatusDropdownContentItemWireframe';
;
var VeltCommentsSidebarStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownContentWireframe.Item = VeltCommentsSidebarStatusDropdownContentItemWireframe;
export default VeltCommentsSidebarStatusDropdownContentWireframe;
